module.exports = __webpack_public_path__ + "static/image 10-63c83d759287469b4bc5df149342e6de.png";